<template>
  <div
    class="ui right vertical very wide overlay sidebar menu"
    ref="sidebar"
    v-bind:class="{ visible: visible }"
  >
    <div style="padding: 10px">
      <div class="container">
        <h2 class="ui header">
          <i :class="this.icon + ' icon' || '?'"></i>
          <div class="content">
            <span class>
              {{
                this.$props.element && this.$props.element.ngine_configuration
                  ? this.$props.element.ngine_configuration.name
                  : "?"
              }}
            </span>
            <div class="sub header">{{ sub_header }}</div>
          </div>
        </h2>
        <component
          :is="component"
          :element="$props.element || {}"
          :project="$props.project"
          :process="$props.process"
          :modeler="$props.modeler"
          :databases="$props.databases"
          :datasources="$props.datasources"
          @cancel="cancel"
          @ok="ok"
          @change_element_color="change_element_color"
        />
      </div>
    </div>
  </div>
</template>

<script>
import StartEventSidebar from "./StartEvent/StartEventSidebar";
import MessageStartEventSidebar from "./StartEvent/MessageStartEventSidebar";
import EndEventSidebar from "./EndEvent/EndEventSidebar";
import MessageEndEventSidebar from "./EndEvent/MessageEndEventSidebar";
import UserTaskSidebar from "./UserTask/UserTaskSidebar";
import ServiceTaskSidebar from "./ServiceTask/ServiceTaskSidebar";
import TimerBoundaryEventSidebar from "./BoundaryEvent/TimerBoundaryEventSidebar";
// import ConditionalBoundaryEventSidebar from "./BoundaryEvent/ConditionalBoundaryEventSidebar";
import EscalationBoundaryEventSidebar from "./BoundaryEvent/EscalationBoundaryEventSidebar";
import ExclusiveGatewaySidebar from "./ExclusiveGateway/ExclusiveGatewaySidebar";
import SequenceFlowSidebar from "./SequenceFlow/SequenceFlowSidebar";
import CallActivitySidebar from "./CallActivity/CallActivitySidebar";
import SendTaskSidebar from "./SendTask/SendTaskSidebar";
import ScriptTaskSidebar from "./ScriptTask/ScriptTaskSidebar";
import ReceiveTaskSidebar from "./ReceiveTask/ReceiveTaskSidebar";
import DataStoreReferenceSidebar from "./DataStoreReference/DataStoreReferenceSidebar";
import SubProcessSidebar from "./SubProcess/SubProcessSidebar";
import BusinessRuleTaskSidebar from "./BusinessRuleTask/BusinessRuleTaskSidebar";
import AutomatonTaskSidebar from "./AutomatonTask/AutomatonTaskSidebar";
import APICallTaskSidebar from "./APICallTask/ApiCallTaskSidebar";

export default {
  name: "BaseSidebar",
  data() {
    return { visible: false };
  },
  computed: {
    sub_header() {
      if (this.$props.element) {
        let convertedTypes = {
          "bpmn:SendTask": "bpmn:RESTService",
          "bpmn:ReceiveTask": "bpmn:SOAPService",
        };

        if (
          this.$props.element.businessObject &&
          this.$props.element.custom_type
        ) {
          if (this.$props.element.custom_type == "AutomatonCall")
            convertedTypes["bpmn:ServiceTask"] = "ngn:AutomateTask";
          else if (this.$props.element.custom_type == "APICall")
            convertedTypes["bpmn:ServiceTask"] = "ngn:APICallTask";
        }

        let targetType = convertedTypes[this.$props.element.type];
        if (targetType) return targetType;
        else return this.$props.element.type;
      } else return "question sign";
    },
    component() {
      let component = this.configuration ? this.configuration.component : null;
      return component;
    },
    icon() {
      return this.configuration ? this.configuration.icon : "question sign";
    },
    configuration() {
      let type = this.$props.element ? this.$props.element.type : "";
      let businessObject = this.$props.element
        ? this.$props.element.businessObject
        : {};

      if (type == "bpmn:StartEvent") {
        if (
          businessObject.eventDefinitions &&
          businessObject.eventDefinitions.length > 0
        ) {
          let eventDefinition = businessObject.eventDefinitions[0];
          if (eventDefinition.$type == "bpmn:MessageEventDefinition")
            return {
              icon: "blue flag checkered",
              component: MessageStartEventSidebar,
            };
          else if (eventDefinition.$type == "bpmn:TimerEventDefinition")
            return { icon: "green flag checkered", component: null };
          else if (eventDefinition.$type == "bpmn:SignalEventDefinition")
            return { icon: "yellow flag checkered", component: null };
          else if (eventDefinition.$type == "bpmn:ConditionalEventDefinition")
            return { icon: "purple flag checkered", component: null };
          else return { icon: "question mark", component: null };
        } else
          return { icon: "olive flag checkered", component: StartEventSidebar };
      } else if (type == "bpmn:EndEvent") {
        if (
          businessObject.eventDefinitions &&
          businessObject.eventDefinitions.length > 0
        ) {
          let eventDefinition = businessObject.eventDefinitions[0];
          if (eventDefinition.$type == "bpmn:MessageEventDefinition")
            return { icon: "blue flag", component: MessageEndEventSidebar };
          else if (eventDefinition.$type == "bpmn:EscalationEventDefinition")
            return { icon: "green flag", component: null };
          else if (eventDefinition.$type == "bpmn:ErrorEventDefinition")
            return { icon: "yellow flag", component: null };
          else if (eventDefinition.$type == "bpmn:CompensateEventDefinition")
            return { icon: "purple flag", component: null };
          else if (eventDefinition.$type == "bpmn:SignalEventDefinition")
            return { icon: "olive flag", component: null };
          else if (eventDefinition.$type == "bpmn:TerminateEventDefinition")
            return { icon: "violet flag", component: null };
          else return { icon: "question mark", component: null };
        } else
          return { icon: "flag grey checkered", component: EndEventSidebar };
      } else if (type == "bpmn:IntermediateThrowEvent") {
        if (
          businessObject.eventDefinitions &&
          businessObject.eventDefinitions.length > 0
        ) {
          let ed = businessObject.eventDefinitions[0];
          if (ed.$type == "bpmn:MessageEventDefinition") return "blue flag";
          else if (ed.$type == "bpmn:EscalationEventDefinition")
            return "green flag";
          else if (ed.$type == "bpmn:SignalEventDefinition")
            return "yellow flag";
          else if (ed.$type == "bpmn:LinkEventDefinition") return "purple flag";
          else if (ed.$type == "bpmn:CompensateEventDefinition")
            return "brown flag";
          else return "question mark";
        } else return "project diagram";
      } else if (type == "bpmn:IntermediateCatchEvent") {
        let ed = businessObject.eventDefinitions[0];
        if (ed.$type == "bpmn:MessageEventDefinition") return "blue flag";
        else if (ed.$type == "bpmn:TimerEventDefinition") return "green flag";
        else if (ed.$type == "bpmn:SignalEventDefinition") return "yellow flag";
        else if (ed.$type == "bpmn:LinkEventDefinition") return "purple flag";
        else if (ed.$type == "bpmn:ConditionalEventDefinition")
          return "brown flag";
        else return "project diagram";
      } else if (type == "bpmn:ExclusiveGateway") {
        return {
          icon: "code branch",
          component: ExclusiveGatewaySidebar,
        };
      } else if (type == "bpmn:ParallelGateway") return "project diagram";
      else if (type == "bpmn:ComplexGateway") return "project diagram";
      else if (type == "bpmn:InclusiveGateway") return "project diagram";
      else if (type == "bpmn:EventBasedGateway") return "project diagram";
      else if (type == "bpmn:DataStoreReference") {
        return {
          icon: "project diagram",
          component: DataStoreReferenceSidebar,
        };
      } else if (type == "bpmn:Task") {
        if (
          businessObject.loopCharacteristics &&
          businessObject.loopCharacteristics.$type
        ) {
          let isSequential = businessObject.loopCharacteristics.isSequential;
          let t = businessObject.loopCharacteristics.$type;
          if (t == "bpmn:MultiInstanceLoopCharacteristics") {
            if (isSequential) return "red flag";
            else return "blue flag";
          } else if (t == "bpmn:StandardLoopCharacteristics")
            return "green flag";
          else return "question mark";
        } else return "project diagram";
      } else if (type == "bpmn:SendTask") {
        if (
          businessObject.loopCharacteristics &&
          businessObject.loopCharacteristics.$type
        ) {
          let isSequential = businessObject.loopCharacteristics.isSequential;
          let t = businessObject.loopCharacteristics.$type;
          if (t == "bpmn:MultiInstanceLoopCharacteristics") {
            if (isSequential) return "red flag";
            else return "blue flag";
          } else if (t == "bpmn:StandardLoopCharacteristics")
            return "green flag";
          else return "question mark";
        } else return { icon: "satellite dish", component: SendTaskSidebar };
      } else if (type == "bpmn:ReceiveTask") {
        if (
          businessObject.loopCharacteristics &&
          businessObject.loopCharacteristics.$type
        ) {
          let isSequential = businessObject.loopCharacteristics.isSequential;
          let t = businessObject.loopCharacteristics.$type;
          if (t == "bpmn:MultiInstanceLoopCharacteristics") {
            if (isSequential) return "red flag";
            else return "blue flag";
          } else if (t == "bpmn:StandardLoopCharacteristics")
            return "green flag";
          else return "question mark";
        } else return { icon: "satellite dish", component: ReceiveTaskSidebar };
      } else if (type == "bpmn:UserTask") {
        if (
          businessObject.loopCharacteristics &&
          businessObject.loopCharacteristics.$type
        ) {
          let isSequential = businessObject.loopCharacteristics.isSequential;
          let t = businessObject.loopCharacteristics.$type;
          if (t == "bpmn:MultiInstanceLoopCharacteristics") {
            if (isSequential) return "red flag";
            else return "blue flag";
          } else if (t == "bpmn:StandardLoopCharacteristics")
            return "green flag";
          else return { icon: "question mark", component: null };
        } else return { icon: "user alternate", component: UserTaskSidebar };
      } else if (type == "bpmn:ManualTask") {
        if (
          businessObject.loopCharacteristics &&
          businessObject.loopCharacteristics.$type
        ) {
          let isSequential = businessObject.loopCharacteristics.isSequential;
          let t = businessObject.loopCharacteristics.$type;
          if (t == "bpmn:MultiInstanceLoopCharacteristics") {
            if (isSequential) return "red flag";
            else return "blue flag";
          } else if (t == "bpmn:StandardLoopCharacteristics")
            return "green flag";
          else return "question mark";
        } else return "user alternate";
      } else if (type == "bpmn:BusinessRuleTask") {
        if (
          businessObject.loopCharacteristics &&
          businessObject.loopCharacteristics.$type
        ) {
          let isSequential = businessObject.loopCharacteristics.isSequential;
          let t = businessObject.loopCharacteristics.$type;
          if (t == "bpmn:MultiInstanceLoopCharacteristics") {
            if (isSequential) return "red flag";
            else return "blue flag";
          } else if (t == "bpmn:StandardLoopCharacteristics")
            return "green flag";
          else return "question mark";
        } else return { icon: "database", component: BusinessRuleTaskSidebar };
      } else if (type == "bpmn:ServiceTask") {
        if (this.$props.element.custom_type == "AutomatonCall") {
          return { icon: "robot", component: AutomatonTaskSidebar };
        } else if (this.$props.element.custom_type == "APICall") {
          return {
            icon: "server",
            component: APICallTaskSidebar,
          };
        } else {
          if (
            businessObject.loopCharacteristics &&
            businessObject.loopCharacteristics.$type
          ) {
            let isSequential = businessObject.loopCharacteristics.isSequential;
            let t = businessObject.loopCharacteristics.$type;
            if (t == "bpmn:MultiInstanceLoopCharacteristics") {
              if (isSequential) return "red flag";
              else return "blue flag";
            } else if (t == "bpmn:StandardLoopCharacteristics")
              return "green flag";
            else return "question mark";
          } else return { icon: "chart pie", component: ServiceTaskSidebar };
        }
      } else if (type == "bpmn:ScriptTask") {
        if (
          businessObject.loopCharacteristics &&
          businessObject.loopCharacteristics.$type
        ) {
          let isSequential = businessObject.loopCharacteristics.isSequential;
          let t = businessObject.loopCharacteristics.$type;
          if (t == "bpmn:MultiInstanceLoopCharacteristics") {
            if (isSequential) return "red flag";
            else return "blue flag";
          } else if (t == "bpmn:StandardLoopCharacteristics")
            return "green flag";
          else return "question mark";
        } else return { icon: "code", component: ScriptTaskSidebar };
      } else if (type == "bpmn:CallActivity") {
        if (
          businessObject.loopCharacteristics &&
          businessObject.loopCharacteristics.$type
        ) {
          let isSequential = businessObject.loopCharacteristics.isSequential;
          let t = businessObject.loopCharacteristics.$type;
          if (t == "bpmn:MultiInstanceLoopCharacteristics") {
            if (isSequential) return "red flag";
            else return "blue flag";
          } else if (t == "bpmn:StandardLoopCharacteristics")
            return { icon: "question mark", component: null };
          else return "question mark";
        } else
          return { icon: "satellite dish", component: CallActivitySidebar };
      } else if (type == "bpmn:SubProcess") {
        if (
          businessObject.loopCharacteristics &&
          businessObject.loopCharacteristics.$type
        ) {
          let isSequential = businessObject.loopCharacteristics.isSequential;
          let t = businessObject.loopCharacteristics.$type;
          if (t == "bpmn:MultiInstanceLoopCharacteristics") {
            if (isSequential) return "red flag";
            else return "blue flag";
          } else if (t == "bpmn:StandardLoopCharacteristics")
            return "green flag";
          else return "question mark";
        } else return { icon: "setting", component: SubProcessSidebar };
      } else if (type == "bpmn:AdHocSubProcess") {
        return "users alternate";
      } else if (type == "bpmn:DataObjectReference") {
        return "settings";
      } else if (type == "bpmn:DataStoreReference") {
        return "database";
      } else if (type == "bpmn:SequenceFlow") {
        return {
          icon: "arrow right",
          component: SequenceFlowSidebar,
        };
      } else if (type == "bpmn:DataOutputAssociation") {
        return "comment alternate";
      } else if (type == "bpmn:DataInputAssociation") {
        return "comment alternate";
      } else if (type == "bpmn:BoundaryEvent") {
        if (businessObject.eventDefinitions) {
          var _ed = businessObject.eventDefinitions.find((x) => x);
          // let ed = businessObject.eventDefinitions[0];
          if (_ed.$type == "bpmn:MessageEventDefinition") return "blue flag";
          else if (_ed.$type == "bpmn:EscalationEventDefinition")
            return {
              icon: "database",
              component: EscalationBoundaryEventSidebar,
            };
          else if (_ed.$type == "bpmn:SignalEventDefinition")
            return "yellow flag";
          else if (_ed.$type == "bpmn:ConditionalEventDefinition")
            return "orange flag";
          else if (_ed.$type == "bpmn:CancelEventDefinition")
            return "gray flag";
          else if (_ed.$type == "bpmn:ErrorEventDefinition")
            return "brown flag";
          else if (_ed.$type == "bpmn:CompensateEventDefinition")
            return "orange flag";
          else if (_ed.$type == "bpmn:TimerEventDefinition")
            return {
              icon: "clock outline",
              component: TimerBoundaryEventSidebar,
            };
          else return "comment alternate";
        } else return "?";
      } else return "question mark";
    },
  },
  props: {
    process: Object,
    element: Object,
    project: Object,
    context: Object,
    modeler: Object,
    databases: Array,
    datasources: Array,
  },
  mounted() {
    let vm = this;
    setTimeout(function() {
      window.jQuery(vm.$refs.sidebar).sidebar({
        transition: "overlay",
        dimPage: false,
        context: vm.$props.context,
      });
    });
  },
  methods: {
    ok(data) {
      this.$props.element.ngine_configuration = data;
      this.$emit("save_configuration", this.$props.element);
    },
    cancel() {
      // this.sidebar.sidebar("hide");
    },
    change_element_color(value) {
      let vm = this;
      var modeling = vm.modeler.get("modeling");
      modeling.setColor(vm.element, {
        //stroke: _stroke,
        fill: value,
      });
    },
  },
  watch: {
    element() {
      let allowedComponents = [
        "bpmn:UserTask",
        "bpmn:StartEvent",
        "bpmn:EndEvent",
        "bpmn:ExclusiveGateway",
        "bpmn:SequenceFlow",
        "bpmn:SendTask",
        "bpmn:ReceiveTask",
        "bpmn:ScriptTask",
        "bpmn:BoundaryEvent",
        "bpmn:SubProcess",
        "bpmn:BusinessRuleTask",
        "bpmn:DataStoreReference",
        "bpmn:ServiceTask",
      ];
      let type = this.element.type;
      let isAllowed = allowedComponents.includes(type);

      let shouldShow = true;
      if (this.element.type == "bpmn:SequenceFlow") {
        let id = this.element.source.id;
        let trgtDefinition = this.$props.process.setup.definitions.find(
          (n) => n.id == id,
        );
        shouldShow =
          // console.log(id, this.$props.process.setup.definitions);
          // let trgt = this.$props.process.setup.definitions.find(n => n.id == id);
          // console.log(trgt);
          trgtDefinition
            ? trgtDefinition.$type == "bpmn:ExclusiveGateway"
            : false;
      }

      let show = isAllowed && shouldShow;
      // if (!show) console.log(type);
      this.visible = show;
    },
  },
};
</script>

<style>
.vue-swatches__trigger {
  border: 1px solid #3333;
}
</style>
